import {AfterViewInit, Component, ComponentFactoryResolver, Inject, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {SettingsComponent} from '../settings.component';
import {AppComponent} from '../../app.component';
import {PartnerOnboardComponent} from '../../partner-onboard/partner-onboard.component';
import {MAT_DIALOG_DATA, MatCheckboxChange, MatDialog, MatSnackBar} from '@angular/material';
import {CreateDatabaseDuringSignUpComponent} from '../../signup/signup.component';
import {ConfService} from '../../conf.service';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {environment} from '../../../environments/environment.prod';
import * as CryptoJS from 'crypto-js';
import {Router} from '@angular/router';
import {DatabasesListenerService} from '../../databases-listener.service';
import {forEachComment} from 'tslint';
import {InjectLogsDirective} from '../../deploymentplan/deploymentplan.component';
import {ProgressLogsComponent} from '../../progress-logs/progress-logs.component';
import { Orientation, TourStep } from 'ngx-guided-tour';
import {AccountInfoService} from '../../user/account-info.service';

declare let $;

@Component({
    selector: 'app-databases',
    templateUrl: './databases.component.html',
    styleUrls: ['./databases.component.scss']
})
export class DatabasesComponent implements OnInit {

    constructor(public settingComp: PartnerOnboardComponent,
                private appComp: AppComponent,
                private dialog: MatDialog, private confPost: ConfService,
                public platform: LeftpanelComponent,
                public router: Router,
                public accountInfoService: AccountInfoService,
                public databasesListenerInstance: DatabasesListenerService,
                private _componentFactoryResolver: ComponentFactoryResolver,) {
        settingComp.loadingStatus.subscribe(
            (status) => {
                if (status === 'true') {
                    this.loading = true;
                } else if (status === 'false') {
                    this.loading = false;
                    this.createDatabasesComponent();
                }
            }
        );
    }

    @Input() inputPartner = '';
    @Input() inputAccount = '';
    @Input() configurations: any;
    @Input() environment: any;

    selectedDB: any;
    @Input() partner = localStorage.getItem('partner');
    @Input() account = localStorage.getItem('account');
    creationOfConnections = [];
    loading = true;
    partnerCode: any;
    accountId: any;
    environmentType = '';
    adminSettingsPayload: any;
    actionToShowArray = [];
    partnerDatabases: any;
    dataBaseData = [];
    passphrase = environment.cipheringPhrase;
    iterationCount = 1000;
    keySize = 128;
    isSettingsDBHasEncryptedProperty = true;
    isDatabaseFormLoading = false;
    componentRef;
    @ViewChild(InjectLogsDirective, {static: false}) injectComp: InjectLogsDirective;
    @Input() data: any;
    isComponentRefInitialized = false;

    async ngOnInit() {

        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }

        if (this.platform.databasesMeta === null || this.platform.databasesMeta === undefined || this.platform.databasesMeta === '') {
            this.confPost.getData('services', 'services', 'v1', 'databaseConfigurations', null).subscribe(response => {
                if (response && response[0]) {
                    this.platform.databasesMeta = response;
                } else {
                    this.platform.databasesMeta = this.platform.databasesMetaDefault;
                }
            }, error => {
                this.platform.databasesMeta = this.platform.databasesMetaDefault;
            });
        }

        this.keySize = this.keySize / 32;

        if (this.inputPartner !== '' && this.inputAccount !== '') {
            this.partner = this.inputPartner;
            this.account = this.inputAccount;
        } else {
            this.partner = localStorage.getItem('partner');
            this.account = localStorage.getItem('account');
        }

        // const code = localStorage.getItem('partner');
        // const acc = localStorage.getItem('account');
        const code = this.partner;
        const acc = this.account;
        const temp = code.split('-');
        if (temp.length > 1) {
            this.environmentType = temp[0];
            this.partnerCode = temp[temp.length - 1];
        } else {
            this.partnerCode = code;
        }
        const temp1 = acc.split('-');
        if (temp1.length > 1) {
            this.accountId = temp1[temp1.length - 1];
        } else {
            this.accountId = acc;
        }
        if (this.platform.databasesMeta === null || this.platform.databasesMeta === undefined || this.platform.databasesMeta === '') {
            this.platform.databasesMeta = this.platform.databasesMetaDefault;
        }
        this.confPost.getSettingsV2CRUD('admin-' + this.partnerCode, 'admin-' + this.accountId, false).subscribe(response => {
            if (response['body'] && response['body'][0]) {
                this.actionToShowArray = [];
                this.adminSettingsPayload = response['body'][0];
                if (localStorage.getItem('selectDB')) {
                    this.selectedDB = localStorage.getItem(('selectDB'));
                    this.settingComp.defaultDB = localStorage.getItem('selectDB');
                    this.settingComp.getSelectedDBColumn(this.selectedDB);
                } else {
                    this.selectedDB = 'mongodb';
                    this.settingComp.defaultDB = 'mongodb';
                }
                this.getDatabases();

            } else {
                this.actionToShowArray = [];
                if (localStorage.getItem('selectDB')) {
                    this.selectedDB = localStorage.getItem(('selectDB'));
                    this.settingComp.defaultDB = localStorage.getItem('selectDB');
                    this.settingComp.getSelectedDB(this.selectedDB);
                } else {
                    this.selectedDB = 'mongodb';
                    this.settingComp.defaultDB = 'mongodb';
                    this.settingComp.getSelectedDB(this.selectedDB);
                }
            }
        });
        this.appComp.currentPageTitle = 'Manage Databases';
        // this.appComp.ribbon = 'Database Management';
        if (!this.settingComp.item) {
            this.settingComp.setcolumnvalues();
        }
        this.platform.setGuideTourSteps(this.getconnectingDatabaseTourSteps());
    }

    createDatabasesComponent() {
        if (!this.isComponentRefInitialized && this.data && this.data.fromDataCatalog) {
            if (this.componentRef) {
                this.componentRef.destroy();
            }
            setTimeout(() => {
                const componentFactory = this._componentFactoryResolver.resolveComponentFactory(CreateDatabaseDuringSignUpComponent);
                this.componentRef = this.injectComp.viewContainerRef.createComponent(componentFactory);
                this.componentRef.instance.configType = 'external';
                this.componentRef.instance.partner = this.partner;
                this.componentRef.instance.account = this.account;
                this.componentRef.instance.fromDataCatalog = true;
            }, 500);
            this.isComponentRefInitialized = true;
        }
    }


    updateDBInEncryptedFormatInSettings(environmentName, databases) {
        return new Promise((resolve, reject) => {
            this.confPost.getSettingsV2CRUD(environmentName, environmentName, false).subscribe(response => {
                if (response['body'] && response['body'][0]) {
                    if (response['body'][0]['environments']) {
                        response['body'][0]['environments'].forEach((env) => {
                            if (env['name'] === environmentName) {
                                if (env['services']) {
                                    for (let i = 0; i < env['services'].length; i++) {
                                        if (env['services'][i]['type'] === 'databases') {
                                            env['services'][i]['configurations'] = databases;
                                            if (response['body'][0].hasOwnProperty('isEnabled')) {
                                                delete response['body'][0].isEnabled;
                                            }
                                            this.confPost.patchEntityData('services', 'services', 'v2', 'settings', response['body'][0]['id'], response['body'][0]).subscribe(response2 => {
                                                resolve('success');
                                            }, error => {
                                                resolve('failed');
                                            });
                                        }
                                    }
                                } else {
                                    resolve('failed');
                                }
                            }
                        });
                    } else {
                        resolve('failed');
                    }
                } else {
                    resolve('failed');
                }
            }, error => {
                resolve('failed');
            });
        });
    }

    async getDatabases() {
        if (this.environment !== undefined && this.environment !== null && this.configurations !== undefined && this.configurations !== null && this.inputPartner !== '' && this.inputAccount !== '') {
            const databaseService = this.environment['services'].filter(element => element.type === 'databases');
            this.partnerDatabases = databaseService[0]['configurations'];
            if (this.partnerDatabases) {
                if (this.partnerDatabases.length > 0) {
                    for (let j = 0; j < this.partnerDatabases.length; j++) {
                        if (this.partnerDatabases[j]) {
                            const database = this.partnerDatabases[j];
                            if ((!database.hasOwnProperty('shash') || !database.hasOwnProperty('ralam')) && database.hasOwnProperty('database_attributes')) {
                                this.isSettingsDBHasEncryptedProperty = false;
                                const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
                                const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
                                const attributes = Object.keys(database['database_attributes']);
                                if (attributes && attributes.length > 0) {
                                    database['shash'] = salt;
                                    database['ralam'] = iv;
                                    for (let i = 0; i < attributes.length; i++) {
                                        await this.platform.encryptAttribute(salt, iv, this.passphrase, database['database_attributes'][attributes[i]], this.keySize, this.iterationCount).then(response1 => {
                                            database['database_attributes'][attributes[i]] = response1;
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
                if (this.isSettingsDBHasEncryptedProperty === false) {
                    await this.updateDBInEncryptedFormatInSettings(environment['name'], this.partnerDatabases);
                }
                await this.partnerDatabases.forEach(async (database) => {
                    if (database.hasOwnProperty('shash') && database.hasOwnProperty('ralam') && database.hasOwnProperty('database_attributes')) {
                        const dattributes = Object.keys(database['database_attributes']);
                        if (dattributes && dattributes.length > 0) {
                            if (database['database_type'] === 'csv') {
                                const fileAttributes = Object.keys(database['database_attributes']['files'][0]);
                                for (let i = 0; i < fileAttributes.length; i++) {
                                    await this.platform.decryptAttribute(database['shash'], database['ralam'], this.passphrase, database['database_attributes']['files'][0][fileAttributes[i]], this.keySize, this.iterationCount).then(response => {
                                        database['database_attributes'][fileAttributes[i]] = response;
                                    });
                                }
                                await this.platform.decryptAttribute(database['shash'], database['ralam'], this.passphrase, database['database_attributes']['connectionType'], this.keySize, this.iterationCount).then(response => {
                                    database['database_attributes']['connectionType'] = response;
                                });
                                if (database['database_attributes']['separator'] && database['database_attributes']['separator'] !== '') {
                                    await this.platform.decryptAttribute(database['shash'], database['ralam'], this.passphrase, database['database_attributes']['separator'], this.keySize, this.iterationCount).then(response => {
                                        database['database_attributes']['separator'] = response;
                                    });
                                }
                            } else {
                                for (let i = 0; i < dattributes.length; i++) {
                                    await this.platform.decryptAttribute(database['shash'], database['ralam'], this.passphrase, database['database_attributes'][dattributes[i]], this.keySize, this.iterationCount).then(response => {
                                        database['database_attributes'][dattributes[i]] = response;
                                    });
                                }
                            }

                        }
                    }
                });
                this.partnerDatabases.filter(items => {
                    if (items.database_type === this.selectedDB) {
                        this.dataBaseData.push(items);
                        this.actionToShowArray.push(true);
                    }
                });
                if (this.adminSettingsPayload) {
                    for (let i = 0; i < this.adminSettingsPayload['environments'][0]['services'].length; i++) {
                        if (this.adminSettingsPayload['environments'][0]['services'][i]['type'] === 'databases') {
                            for (let j = 0; j < this.adminSettingsPayload['environments'][0]['services'][i]['configurations'].length; j++) {
                                for (let k = 0; k < this.dataBaseData.length; k++) {
                                    if (this.adminSettingsPayload['environments'][0]['services'][i]['configurations'][j]['database_name'] === this.dataBaseData[k]['database_name']) {
                                        if (this.environmentType !== 'admin') {
                                            this.actionToShowArray[k] = false;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                this.loading = false;
                this.createDatabasesComponent();
            }
        } else {
            // this.confPost.getDatabases(this.partner).subscribe(data => {
            // if (this.platform.databases !== null && this.platform.databases !== undefined) {
            //     this.partnerDatabases = this.platform.databases;
            // } else {
            //     // this.platform.getDatabasesForPartnerAccount();
            //     this.confPost.getDatabases(localStorage.getItem('partner')).subscribe(databases => {
            //             this.partnerDatabases = databases;
            //             this.platform.databases = databases;
            //         },
            //         error => {
            //             this.platform.openSnackBar('Error while getting list of databases: ' + error.error.message, 'Error', {
            //                 duration: 5000,
            //                 verticalPosition: 'top',
            //                 horizontalPosition: 'center'
            //             });
            //         });
            // }
            this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(async response => {
                if (response['body'] && response['body'][0]) {
                    const environment = response['body'][0]['environments'][0];
                    const databaseService = environment['services'].filter(element => element.type === 'databases');
                    this.partnerDatabases = databaseService[0]['configurations'];
                    // this.partnerDatabases = data;
                    if (this.partnerDatabases) {
                        if (this.partnerDatabases.length > 0) {
                            for (let j = 0; j < this.partnerDatabases.length; j++) {
                                if (this.partnerDatabases[j]) {
                                    const database = this.partnerDatabases[j];
                                    if (database.hasOwnProperty('database_name')) {
                                        if (database && (!database.hasOwnProperty('shash') || !database.hasOwnProperty('ralam')) && database.database_name !== 'default' && database.hasOwnProperty('database_attributes')) {
                                            this.isSettingsDBHasEncryptedProperty = false;
                                            const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
                                            const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
                                            const attributes = Object.keys(database['database_attributes']);
                                            if (attributes && attributes.length > 0) {
                                                database['shash'] = salt;
                                                database['ralam'] = iv;
                                                for (let i = 0; i < attributes.length; i++) {
                                                    await this.platform.encryptAttribute(salt, iv, this.passphrase, database['database_attributes'][attributes[i]], this.keySize, this.iterationCount).then(response1 => {
                                                        database['database_attributes'][attributes[i]] = response1;
                                                    });
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            if (this.isSettingsDBHasEncryptedProperty === false) {
                                await this.updateDBInEncryptedFormatInSettings(this.partner, this.partnerDatabases);
                            }
                        }
                        await this.partnerDatabases.forEach(async (database) => {
                            if (database.hasOwnProperty('shash') && database.hasOwnProperty('shash') && database.hasOwnProperty('database_attributes')) {
                                const dattributes = Object.keys(database['database_attributes']);
                                if (dattributes && dattributes.length > 0) {
                                    if (database['database_type'] === 'csv') {
                                        const fileAttributes = Object.keys(database['database_attributes']['files'][0]);
                                        for (let i = 0; i < fileAttributes.length; i++) {
                                            await this.platform.decryptAttribute(database['shash'], database['ralam'], this.passphrase, database['database_attributes']['files'][0][fileAttributes[i]], this.keySize, this.iterationCount).then(response => {
                                                database['database_attributes'][fileAttributes[i]] = response;
                                            });
                                        }
                                        await this.platform.decryptAttribute(database['shash'], database['ralam'], this.passphrase, database['database_attributes']['connectionType'], this.keySize, this.iterationCount).then(response => {
                                            database['database_attributes']['connectionType'] = response;
                                        });
                                        if (database['database_attributes']['separator'] && database['database_attributes']['separator'] !== '') {
                                            await this.platform.decryptAttribute(database['shash'], database['ralam'], this.passphrase, database['database_attributes']['separator'], this.keySize, this.iterationCount).then(response => {
                                                database['database_attributes']['separator'] = response;
                                            });
                                        }
                                    } else {
                                        for (let i = 0; i < dattributes.length; i++) {
                                            await this.platform.decryptAttribute(database['shash'], database['ralam'], this.passphrase, database['database_attributes'][dattributes[i]], this.keySize, this.iterationCount).then(response => {
                                                database['database_attributes'][dattributes[i]] = response;
                                            });
                                        }
                                    }
                                }
                            }
                        });
                        this.partnerDatabases.filter(items => {
                            if (items.database_type === this.selectedDB) {
                                this.dataBaseData.push(items);
                                this.actionToShowArray.push(true);
                            }
                        });
                        if (this.adminSettingsPayload) {
                            for (let i = 0; i < this.adminSettingsPayload['environments'][0]['services'].length; i++) {
                                if (this.adminSettingsPayload['environments'][0]['services'][i]['type'] === 'databases') {
                                    for (let j = 0; j < this.adminSettingsPayload['environments'][0]['services'][i]['configurations'].length; j++) {
                                        for (let k = 0; k < this.dataBaseData.length; k++) {
                                            if (this.adminSettingsPayload['environments'][0]['services'][i]['configurations'][j]['database_name'] === this.dataBaseData[k]['database_name']) {
                                                if (this.environmentType !== 'admin') {
                                                    this.actionToShowArray[k] = false;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                } else {
                    this.platform.openSnackBar('Error while fetching database connections. Please try again after sometime.', 'Error', {
                        duration: 20000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
                this.loading = false;
                this.createDatabasesComponent();
            }, error => {
                this.loading = false;
                //this.createDatabasesComponent();
                this.platform.openSnackBar('Error while fetching database connections' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
                    duration: 20000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
            // });
        }
    }

    // ngOnDestroy(): void {
    //   this.settingComp.loadingStatus.unsubscribe();
    // }

    setItem(val) {
        //this.isDatabaseFormLoading = true;
        localStorage.setItem('selectDB', val);
        if (this.componentRef) {
            this.componentRef.destroy();
        }

        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'databaseconnection_create_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
            const payloadToSend = {
                actions: response
            };
            this.databasesListenerInstance.databasesListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });

        this.settingComp.defaultDB = val;
        this.actionToShowArray = [];
        this.dataBaseData = [];
        this.selectedDB = val;
        this.settingComp.getSelectedDBColumn(val);
        if (this.data && this.data.fromDataCatalog) {
            setTimeout(() => {
                const componentFactory = this._componentFactoryResolver.resolveComponentFactory(CreateDatabaseDuringSignUpComponent);
                this.componentRef = this.injectComp.viewContainerRef.createComponent(componentFactory);
                this.componentRef.instance.configType = 'external';
                this.componentRef.instance.partner = this.partner;
                this.componentRef.instance.account = this.account;
                this.componentRef.instance.fromDataCatalog = true;
            }, 500);
        }
        // setTimeout(() => {
        //     this.isDatabaseFormLoading = false;
        // }, 2000);
        this.getDatabases();
        // this.settingComp.getSelectedDB(this.selectedDB);
        // for (let i = 0; i < this.settingComp.dataBaseData.length; i++) {
        //   this.actionToShowArray.push(true);
        // }
        // if (this.adminSettingsPayload) {
        //   for (let i = 0; i < this.settingComp.dataBaseData.length; i++) {
        //     for (let j = 0; j < this.adminSettingsPayload['configurations']['databases'].length; j++) {
        //       if (this.settingComp.dataBaseData[i]['database_name'] === this.adminSettingsPayload['configurations']['databases'][j]['database_name']) {
        //         if (this.environmentType !== 'admin') {
        //           this.actionToShowArray[i] = false;
        //         }
        //       }
        //     }
        //   }
        // }
    }

    // editDatabase($event, i) {
    //   const id = '#update' + i;
    //   $(id).css('display', 'block');
    //   this.settingComp.editDatabase($event, i);
    // }

    editDatabase(event, i) {
        let index = 0;
        $(event.target).closest('td').parent('tr').find('td').each(function () {
            if ($(this).find('input').length) {
                if (index !== 1) {
                    $(this).find('input').prop('readonly', false);
                }
            }
            $(this).find('button').css('display', 'block');
            index += 1;
        });
        const id = '#update' + i;
        $(id).css('display', 'block');
    }

    patchConnectionInAdmin(partnerName, accountId, result, envType, environments, isFromAdmin, shash, ralam) {
        return new Promise((resolve, reject) => {
            let databaseServiceIndex: number;
            this.confPost.getSettingsV2CRUD(partnerName, accountId, false).subscribe(res => {
                if (res && res['body'] && res['body'][0]) {
                    const response1 = res['body'];
                    let databases: any;
                    if (isFromAdmin === true) {
                        for (let i = 0; i < response1[0]['environments'].length; i++) {
                            for (let j = 0; j < response1[0]['environments'][i]['services'].length; j++) {
                                if (response1[0]['environments'][i]['services'][j]['type'] === 'databases') {
                                    databases = response1[0]['environments'][i]['services'][j];
                                    databaseServiceIndex = j;
                                }
                            }
                            result['audit_logs'] = [];
                            result['is_default'] = false;
                            result['audit_logs'][0] = {
                                action: 'CREATE',
                                by: localStorage.getItem('signInEmail'),
                                at: Date.now()
                            };
                            databases['configurations'].push(result);
                            response1[0]['environments'][i]['services'][databaseServiceIndex] = databases;
                        }
                    } else {
                        for (let i = 0; i < response1[0]['environments'].length; i++) {
                            if (response1[0]['environments'][i]['type'] === envType) {
                                for (let j = 0; j < response1[0]['environments'][i]['services'].length; j++) {
                                    if (response1[0]['environments'][i]['services'][j]['type'] === 'databases') {
                                        databases = response1[0]['environments'][i]['services'][j];
                                        databaseServiceIndex = j;
                                    }
                                }
                                result['audit_logs'] = [];
                                result['is_default'] = false;
                                result['audit_logs'][0] = {
                                    action: 'CREATE',
                                    by: localStorage.getItem('signInEmail'),
                                    at: Date.now()
                                };
                                databases['configurations'].push(result);
                                response1[0]['environments'][i]['services'][databaseServiceIndex] = databases;
                            }
                        }
                    }
                    if (response1[0].hasOwnProperty('isEnabled')) {
                        delete response1[0].isEnabled;
                    }
                    this.confPost.patchEntityData('services', 'services', 'v2', 'settings', response1[0]['id'], response1[0]).subscribe(response2 => {
                        this.creationOfConnections.push('success');
                        if (this.creationOfConnections.length === environments.length) {
                            Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'databaseconnection_create_success', 'INFO', '200', 'OK', '', {
                                partner: partnerName,
                                databasePayload: result
                            }, response2, this.router.url)).then(resp => {
                                const payloadToSend = {
                                    actions: resp
                                };
                                this.databasesListenerInstance.databasesListener.emit({
                                    type: 'audit',
                                    id: localStorage.getItem('IdOfSession'),
                                    payload: payloadToSend
                                });
                            });
                            this.platform.openSnackBar('Database connection created successfully', 'Success', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            setTimeout(() => {
                                window.location.reload();
                            }, 1000);
                        }
                        resolve('success');
                    }, error => {
                        Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'databaseconnection_create_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {
                            partner: partnerName,
                            databasePayload: result
                        }, error, this.router.url)).then(resp => {
                            const payloadToSend = {
                                actions: resp
                            };
                            this.databasesListenerInstance.databasesListener.emit({
                                type: 'audit',
                                id: localStorage.getItem('IdOfSession'),
                                payload: payloadToSend
                            });
                        });
                        this.loading = false;
                    });
                }
            });
        });
    }

    createConnection(partner, account, result, shash, ralam) {
        return new Promise((resolve, reject) => {
            const insertDatabasePayload = {
                shash: shash,
                ralam: ralam,
                databaseDetails: result
            };
            // this.confPost.insertDatabase(partner, insertDatabasePayload).subscribe(data => {

            // Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'databaseconnection_insertdatabase_success', 'INFO', data.status, data.statusText, '', {partner: partner, insertDatabasePayload: insertDatabasePayload}, data, this.router.url)).then(resp => {
            //     const payloadToSend = {
            //         actions: resp
            //     };
            //     this.databasesListenerInstance.databasesListener.emit({
            //         type: 'audit',
            //         id: localStorage.getItem('IdOfSession'),
            //         payload: payloadToSend
            //     });
            // });

            let environments = [];
            // const code = localStorage.getItem('partner');
            // const acc = localStorage.getItem('account');
            const code = partner;
            const acc = account;
            const temp = code.split('-');
            let partnerShortCode = '';
            if (temp.length > 1) {
                partnerShortCode = temp[temp.length - 1];
            } else {
                partnerShortCode = code;
            }
            const temp1 = acc.split('-');
            let account_id = '';
            if (temp1.length > 1) {
                account_id = temp1[temp1.length - 1];
            } else {
                account_id = acc;
            }
            this.confPost.getSettingsV2CRUD(partner, account, false).subscribe(async response => {
                if (response && response['body'] && response['body'][0]) {
                    environments = response['body'][0]['environments'];
                    if (response['body'][0]['environments'][0]['type'] === 'admin') {
                        let index = 0;
                        for (const env of environments) {
                            index += 1;
                            let partnerName = '';
                            let accountId = '';
                            if (env['type'] !== 'prod') {
                                partnerName = env['type'] + '-' + partnerShortCode;
                                accountId = env['type'] + '-' + account_id;
                            } else {
                                partnerName = partnerShortCode;
                                accountId = account_id;
                            }
                            await this.patchConnectionInAdmin(partnerName, accountId, result, env['type'], environments, true, shash, ralam);
                        }
                    } else {
                        let databases: any;
                        let databaseServiceIndex: number;
                        for (let i = 0; i < response['body'][0]['environments'][0]['services'].length; i++) {
                            if (response['body'][0]['environments'][0]['services'][i]['type'] === 'databases') {
                                databases = response['body'][0]['environments'][0]['services'][i];
                                databaseServiceIndex = i;
                            }
                        }
                        result['audit_logs'] = [];
                        result['is_default'] = false;
                        result['audit_logs'][0] = {
                            action: 'CREATE',
                            by: localStorage.getItem('signInEmail'),
                            at: Date.now()
                        };
                        databases['configurations'].push(result);
                        response['body'][0]['environments'][0]['services'][databaseServiceIndex] = databases;
                        if (response['body'][0].hasOwnProperty('isEnabled')) {
                            delete response['body'][0].isEnabled;
                        }
                        this.confPost.patchEntityData('services', 'services', 'v2', 'settings', response['body'][0]['id'], response['body'][0]).subscribe(async response2 => {
                            this.patchConnectionInAdmin('admin-' + partnerShortCode, 'admin-' + account_id, result, response['body'][0]['environments'][0]['type'], environments, false, shash, ralam).then(async response3 => {
                                this.platform.openSnackBar('Database connection created successfully', 'Success', {
                                    duration: 5000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                                // window.location.reload();
                                resolve('success');
                            }, async error => {
                                await this.platform.notifyErrorToAdmins({error: 'Error occurred while patching the admin partner settings for the partner ' + partner + ' while creating a database connection.'}, 'databaseconnection_create_notifyerrortoadmins_success', 'databaseconnection_create_notifyerrortoadmins_failed', 'Error occurred while patching the admin partner settings for the partner ' + partner + ' while creating a database connection.', {
                                    partner: partner,
                                    account: account,
                                    data: result
                                });
                                this.loading = false;
                            });
                        }, async error => {
                            await this.platform.notifyErrorToAdmins({error: 'Error occurred while patching the partner settings for the partner ' + partner + ' while creating a database connection.'}, 'databaseconnection_create_notifyerrortoadmins_success', 'databaseconnection_create_notifyerrortoadmins_failed', 'Error occurred while patching the partner settings for the partner ' + partner + ' while creating a database connection.', {
                                partner: partner,
                                account: account,
                                data: result
                            });
                            this.loading = false;
                        });
                    }
                } else {
                    this.platform.openSnackBar('Error while fetching database connections. Please try again after sometime.', 'Error', {
                        duration: 20000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    await this.platform.notifyErrorToAdmins({error: 'No data has been from the partner settings for the partner ' + partner + ' while creating a database connection.'}, 'databaseconnection_create_notifyerrortoadmins_success', 'databaseconnection_create_notifyerrortoadmins_failed', 'No data has been fetched from the partner settings for the partner ' + partner + ' while creating a database connection.', {
                        partner: partner,
                        account: account,
                        data: result
                    });
                    this.loading = false;
                }
            }, async error => {
                this.platform.handleErrorGracefully(error, 'Error occurred while fetching the DB Connections. Please try again after sometime.');
                await this.platform.notifyErrorToAdmins({error: 'Error while fetching the data from the partner settings for the partner ' + partner + ' while creating a database connection.'}, 'databaseconnection_create_notifyerrortoadmins_success', 'databaseconnection_create_notifyerrortoadmins_failed', 'Error while fetching the data from the partner settings for the partner ' + partner + ' while creating a database connection.', {
                    partner: partner,
                    account: account,
                    data: result
                });
                this.loading = false;
            });
            // }, async error => {
            //     Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'databaseconnection_insertdatabase_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {partner: partner, insertDatabasePayload: insertDatabasePayload}, error, this.router.url)).then(resp => {
            //         const payloadToSend = {
            //             actions: resp
            //         };
            //         this.databasesListenerInstance.databasesListener.emit({
            //             type: 'audit',
            //             id: localStorage.getItem('IdOfSession'),
            //             payload: payloadToSend
            //         });
            //     });
            //     this.platform.handleErrorGracefully(error, 'Error occurred while creating the DB Connection. Please try again after sometime.');
            //     await this.platform.notifyErrorToAdmins({error: 'Error while creating a DB Connection for the partner ' + partner + '.'}, 'databaseconnection_create_notifyerrortoadmins_success', 'databaseconnection_create_notifyerrortoadmins_failed', 'Error while creating a DB Connection for the partner ' + partner + '.', {
            //         partner: partner,
            //         account: account,
            //         data: result
            //     });
            //     this.loading = false;
            // });
        });
    }

    openDialog(configType, partner, account) {

        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'databaseconnection_create_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
            const payloadToSend = {
                actions: response
            };
            this.databasesListenerInstance.databasesListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });

        const dialogRef = this.dialog.open(CreateDatabaseDuringSignUpComponent, {
            disableClose: true,
            height: 'auto',
            width: '50%',
            data: {
                configType: configType,
                partner: partner,
                account: account
            }
        });

        dialogRef.afterClosed().subscribe(async result => {
            this.databasesDialogClosed(result, configType);
        });
    }

    async databasesDialogClosed(result, configType) {
        this.loading = true;
        this.creationOfConnections = [];
        // let environments = [];
        if (result !== undefined) {
            result['connection_provider'] = configType;
            const iterationCount = 1000;
            let keySize = 128;
            keySize = keySize / 32;
            const passphrase = environment.cipheringPhrase;

            const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
            const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
            result['shash'] = salt;
            result['ralam'] = iv;
            const attributes = Object.keys(result['database_attributes']);
            if (attributes && attributes.length > 0) {
                if (result['database_type'] === 'csv') {

                    const files = Object.keys(result['database_attributes']['files']);
                    for (let j = 0; j < files.length; j++) {
                        const fileAttributes = Object.keys(result['database_attributes']['files'][j]);
                        for (let i = 0; i < fileAttributes.length; i++) {
                            await this.platform.encryptAttribute(salt, iv, passphrase, result['database_attributes']['files'][j][fileAttributes[i]], keySize, iterationCount).then(response => {
                                result['database_attributes']['files'][j][fileAttributes[i]] = response;
                            });
                        }
                    }
                    await this.platform.encryptAttribute(salt, iv, passphrase, result['database_attributes']['connectionType'], keySize, iterationCount).then(response => {
                        result['database_attributes']['connectionType'] = response;
                    });
                    await this.platform.encryptAttribute(salt, iv, passphrase, result['database_attributes']['connectTo'], keySize, iterationCount).then(response => {
                        result['database_attributes']['connectTo'] = response;
                    });
                    await this.platform.encryptAttribute(salt, iv, passphrase, result['database_attributes']['connector'], keySize, iterationCount).then(response => {
                        result['database_attributes']['connector'] = response;
                    });
                    await this.platform.encryptAttribute(salt, iv, passphrase, result['database_attributes']['file_selector'], keySize, iterationCount).then(response => {
                        result['database_attributes']['file_selector'] = response;
                    });
                    await this.platform.encryptAttribute(salt, iv, passphrase, result['database_attributes']['URL'], keySize, iterationCount).then(response => {
                        result['database_attributes']['URL'] = response;
                    });
                    if (result['database_attributes']['separator'] && result['database_attributes']['separator'] !== '') {
                        await this.platform.encryptAttribute(salt, iv, passphrase, result['database_attributes']['separator'], keySize, iterationCount).then(response => {
                            result['database_attributes']['separator'] = response;
                        });
                    }
                } else {
                    for (let i = 0; i < attributes.length; i++) {
                        await this.platform.encryptAttribute(salt, iv, passphrase, result['database_attributes'][attributes[i]], keySize, iterationCount).then(response => {
                            result['database_attributes'][attributes[i]] = response;
                        });
                    }
                }

            }
            if (result['database_type'] === 'mongodb' || result['database_type'] === 'dynamodb') {
                result['is_nosql'] = true;
            } else {
                result['is_nosql'] = false;
            }
            this.createConnection(this.partner, this.account, result, salt, iv);
        } else {
            this.loading = false;
        }
    }

    getconnectingDatabaseTourSteps():Array<TourStep>{
        let steps: TourStep[] = [];
        steps.push({
            title: this.platform.getProperty('GT_CONNECTING_DATABASE_TITLE'),
            content: this.platform.getProperty('GT_CONNECTING_DATABASE_CONTENT'),
        },{
            title: this.platform.getProperty('GT_DATABASES_TYPE_TITLE'),
            selector: '.tour-create-database-DBlist',
            content: this.platform.getProperty('GT_DATABASES_TYPE_CONTENT'),
            orientation:  Orientation.Bottom
        },{
            title: this.platform.getProperty('GT_DATABASES_ADD_BUTTON_TITLE'),
            selector: '.apiplatform-btn',
            content: this.platform.getProperty('GT_DATABASES_ADD_BUTTON_CONTENT'),
            orientation: Orientation.Left   
        },{
            title: this.platform.getProperty('GT_DATABASES_FROM_TITLE'),
            selector: '.apiplatform-btn',
            content: this.platform.getProperty('GT_DATABASES_FROM_CONTENT'),
            orientation: Orientation.Left,
            action: (()=> {this.openDialog('apiplatform', this.partner, this.account)})
        },{
            title: this.platform.getProperty('GT_CONFIG_DATABASES_FROM_TITLE'),
            selector: '.apiplatform-btn',
            content: this.platform.getProperty('GT_CONFIG_DATABASES_FROM_CONTENT'),
            orientation: Orientation.Left,
            action: (()=> {this.openDialog('external', this.partner, this.account)})
        }
        );
        return steps;
    }

    createPaddingRight() {
        document.getElementById('view:databases').style.paddingRight = '400px';
    }

    removePaddingRight() {
        document.getElementById('view:databases').style.paddingRight = '0px';
    }
}
